import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prodBaseUrl as BASE_URL } from "../constants";

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/api`,
  }),
  refetchOnFocus: true,
  tagTypes: [
    "AdminDestinationList",
    "DestinationDetail",
    "DestinationList",
    "DestinationImages",
    "DestinationOptions",
    "AdminAdventureList",
    "AdminProgrammeList",
    "CountriesListOptions",
    "AdminAdventureList",
    "AdminProgrammeList",
    "AdventureOptions",
    "AdventureDetail",
    "ProgrammeDetail",
  ],
  endpoints: () => ({}),
});
